import { DSNCEmbedTiktok, DSNCEmbedYoutube, DSVideo } from 'shared-definitions/types'
import { nullableString } from 'shared-code/conversion'
import { youtubeVideoId } from 'shared-code/string'
import { ApiComponentEmbed } from 'data-source/types.wp'

type EmbedType = 'tiktok' | 'youtube'

export function ncEmbed(input: ApiComponentEmbed): DSNCEmbedYoutube | DSNCEmbedTiktok | [] {
  const embedType = getEmbedType(input)
  if (embedType === 'tiktok') {
    return tiktokMapper(input)
  }

  return youtubeMapper(input)
}

function getEmbedType(input: ApiComponentEmbed): EmbedType {
  if (/www\.tiktok\.com/.test(input.text)) {
    return 'tiktok'
  }
  return 'youtube'
}

function tiktokMapper(input: ApiComponentEmbed): DSNCEmbedTiktok | [] {
  const parsed = /\/\/www.tiktok.com\/[^/]+\/video\/([^/]+)/.exec(input.text)
  if (!parsed) {
    return []
  }

  return {
    resource: 'nc-embed-tiktok',
    videoId: parsed[1],
  }
}

function youtubeMapper(input: ApiComponentEmbed): DSNCEmbedYoutube | [] {
  const video = videoMapper(input.text)

  if (video) {
    return {
      resource: 'nc-embed-youtube',
      video,
    }
  }
  return []
}

function videoMapper(input: string): DSVideo | null {
  const str = nullableString(input)
  if (!str) {
    return null
  }

  const youtubeId = youtubeVideoId(str)
  if (!youtubeId) {
    return null
  }
  return { youtubeId }
}
